import { render, staticRenderFns } from "./SuspectComponent.vue?vue&type=template&id=40c03079&"
import script from "./SuspectComponent.vue?vue&type=script&lang=js&"
export * from "./SuspectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports